import * as z from "zod/v4";

export const updateShopifyDisputeEvidence = {
  name: "updateShopifyDisputeEvidence" as const,
  input: z.object({
    disputeId: z.string(),
    accessActivityLog: z.string().optional(),
    cancellationRebuttal: z.string().optional(),
    uncategorizedText: z.string().optional(),
    productDescription: z.string().optional(),
    refundRefusalExplanation: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
